
function rec(tree, level) {
	const arr = [];
	tree.forEach((a) => {
		arr.push({
			id: a.id,
			isArchived: a.isArchived,
			name: a.name,
			level: (level + 1),
		});
		if (a.children.length > 0) {
			rec(a.children, level + 1).forEach((b) => {
				arr.push(b);
			});
		}
	});
	return arr;
}

export default rec;
